import { QueryKey } from 'query';

export const FINANCE = 'finance';

export const businessKey = new QueryKey(FINANCE);

export const grid = businessKey.grid();
export const grids = businessKey.grids();

export const mutations = businessKey.mutations();
